export const MODIFY_CURR_REQUESTS = 'MODIFY_CURR_REQUESTS';

export function modifyCurrRequests(currRequests){
    return{
        type: MODIFY_CURR_REQUESTS,
        mainState: {
            currRequests: currRequests
        }
    }
}